/* istanbul ignore file */
import { notifyErrors } from 'shared/helpers/logger';
// eslint-disable-next-line import/extensions
import createApp from './app.js';

const { Vue, Vuex } = window;

Vue.config.errorHandler = (e) => {
  notifyErrors('MIDAS_SEO_DESKTOP', e);
};

const data = global.SEO || {};
const { app, router } = createApp({ Vue, Vuex, data, isSSR: false });

router.onReady(() => {
  app.$mount('#app', true);
});
